import React, { useState } from 'react';
import api from '../../services/api';

/**
 * Topic tag bubbles on a Video Library video or an email nudge (Content Pushes) — Jenn, 2026-10-13 +
 * 2026-10-29. Type a topic and press Enter (or pick one already used); × takes it off. Saves straight
 * away. Search uses these, and the lesson editor finds videos by them.
 * kind: 'video' | 'push' | 'announcement' | 'hive_post' | 'hive_comment'. My Hive uses endpoint
 * '/community/tags' (members tag their own). readOnly shows the bubbles only. allTags: [{ tag, n }] for the suggestions list.
 */
export default function TagBubbles({ kind, id, title, initial = [], allTags = [], onSaved, endpoint = '/admin/tags/item', readOnly = false }) {
  const [tags, setTags] = useState(initial);
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const listId = `tag-options-${kind}`;

  const save = async (next) => {
    setSaving(true); setError(null);
    try {
      const { data } = await api.put(endpoint, { kind, id, title, tags: next });
      setTags(data.tags);
      onSaved?.(data.tags);
    } catch (err) {
      setError(err.response?.data?.error || 'Could not save the tags.');
    } finally {
      setSaving(false);
    }
  };
  const add = () => {
    const t = draft.replace(/\s+/g, ' ').trim();
    if (!t) return;
    setDraft('');
    if (tags.some(x => x.toLowerCase() === t.toLowerCase())) return;
    save([...tags, t]);
  };

  if (readOnly) {
    if (!tags.length) return null;
    return (
      <div className="flex flex-wrap items-center gap-1.5">
        {tags.map(t => <span key={t} className="rounded-full bg-reset-sage/10 text-reset-sage text-[11px] font-medium px-2.5 py-0.5">{t}</span>)}
      </div>
    );
  }
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {tags.map(t => (
        <span key={t} className="inline-flex items-center gap-1 rounded-full bg-reset-sage/10 text-reset-sage text-[11px] font-medium pl-2.5 pr-1.5 py-0.5">
          {t}
          <button type="button" onClick={() => save(tags.filter(x => x !== t))} disabled={saving}
            className="text-reset-sage/70 hover:text-reset-brown leading-none" aria-label={`Take off ${t}`}>×</button>
        </span>
      ))}
      <input value={draft} onChange={e => setDraft(e.target.value)} list={listId} disabled={saving}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); add(); } }}
        onBlur={() => draft.trim() && add()}
        placeholder={tags.length ? '+ topic' : '+ add a topic (e.g. sleep, money)'}
        className="min-w-[7rem] flex-1 max-w-[14rem] bg-transparent border-b border-dashed border-gray-200 text-[11px] text-reset-brown px-1 py-0.5 focus:outline-none focus:border-reset-terracotta" />
      <datalist id={listId}>{allTags.map(t => <option key={t.tag} value={t.tag} />)}</datalist>
      {error && <span className="text-[11px] text-reset-brown">{error}</span>}
    </div>
  );
}
